import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import moment from 'moment'

import { IsSSR } from '../helpers/isSSR'

class Infografik extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.isSSR = IsSSR()
    this.sliderRef = React.createRef()
  }

  renderImage(dataFoto) {
    const imageUrl = dataFoto.post?.mediaable?.media?.url || '/assets/img/favicon-ivoox.png'
    return <img src={imageUrl} className="entry__img lazyloaded" alt="" />
  }

  handleNext = () => {
    this.sliderRef.current.slickNext()
  }
  handlePrev = () => {
    this.sliderRef.current.slickPrev()
  }

  render() {
    const { datas, loading } = this.props
    console.log('Infografik datas:', datas)

    if (loading) return null
    return (
      <section className="section mb-24">
        <div style={{ paddingLeft: 0, paddingRight: 0 }} className="infografik">
          <div className="title-wrap title-wrap--line">
            <div className="row">
              <div className="col-md-6" style={{ width: '50%' }}>
                <Link
                  to={{
                    pathname: `/category/infografik`
                  }}
                >
                  <h3 className="section-title">INFOGRAFIK</h3>
                </Link>
              </div>
              {/* <input onChange={this.handleInputChange} type="range" min={0} max={3} /> */}
              <div className="col-md-6 d-flex align-items-center justify-content-end " style={{ gap: '1rem' }}>
                <Link
                  to={{
                    pathname: `/category/infografik`
                  }}
                  style={{ fontSize: '18px', textDecoration: 'underline', fontWeight: 'bold', color: 'black' }}
                >
                  See All
                </Link>
                <div className="d-flex justify-content-center">
                  <button
                    onClick={this.handlePrev}
                    className="px-3 py-2 "
                    style={{ border: '1px solid rgba(12, 12, 12, 0.4)', borderRadius: '2px 0 0 2px', background: 'none' }}
                  >
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 12L0 6L6 0L7.4 1.4L2.8 6L7.4 10.6L6 12Z" fill="#0C0C0C" fill-opacity="0.4" />
                    </svg>
                  </button>
                  <button
                    onClick={this.handleNext}
                    className="px-3 py-2 "
                    style={{ border: '1px solid rgba(12, 12, 12, 0.4)', borderRadius: '0 2px 2px 0', background: 'none' }}
                  >
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="#0C0C0C" fill-opacity="0.4" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Slider
            ref={this.sliderRef}
            {...{
              dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: !this.isSSR && window.outerWidth < 480 ? 1 : 3,
              slidesToScroll: !this.isSSR && window.outerWidth < 480 ? 1 : 3,
              arrows: false
            }}
          >
            {datas.map((data, dataIndex) => (
              <div className="infografik-card" key={dataIndex}>
                <div>{this.renderImage(data)}</div>
                <div className="infografik-footer">
                  <h2 className="entry__title">
                    <Link
                      to={{
                        pathname: `/${data.post.url}`
                      }}
                    >
                      {data.post.title}
                    </Link>
                  </h2>
                  <div style={{ display: 'inline-block' }}>
                    <span style={{ fontWeight: 'bold', color: 'black', marginRight: '4px', display: 'inline-block' }}>BY</span>
                    <Link
                      to={{
                        pathname: `/authorPost/${data.post.user?.username}`
                      }}
                    >
                      {` `} {data.post.user?.name}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    )
  }
}

export default Infografik
